<div class="play-view-loading">
  <div class="shimmerBG playview-media"></div>
</div>
